import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { Navigate, useLocation } from 'react-router-dom';
import PhoneInput, { isValidPhoneNumber } from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import axios from 'axios';
import WebForm from '../components/webform.view';
import WebformPreview from '../components/webform.preview';
import './landing.styles.scss';
import Loader from 'react-spinners/BounceLoader';
import { getQueryParameters } from '../utils/functions';

const API_URL = process.env.REACT_APP_API_URL;

export default function LandingPage() {
  const [commId, setCommId] = useState();
  const [joinCode, setJoinCode] = useState(null);
  const [isUrlValid, setIsURLValid] = useState(true);
  const [accountLogo, setAccountLogo] = useState('');
  const [accountId, setAccountId] = useState('');
  const [hasEmail, setHasEmail] = useState(true);
  const [isEmailOrPhone, setEmailOrPhone] = useState(false);
  const [hasFacebook, setHasFacebook] = useState(false);
  const [hasTwitter, setHasTwitter] = useState(false);
  const [hasInstagram, setHasInstagram] = useState(false);
  const [userMetadata, setUserMetadata] = useState({});
  const [loading, setLoading] = useState(true);
  const [selectedContactMethod, setSelectedContactMethod] = useState('email');
  const [phoneValue, setPhoneValue] = useState();
  const [phoneError, setPhoneError] = useState('');

  const location = useLocation();
  const params = new URLSearchParams(window.location.search);
  const isPreview = (params.get('preview') || '').toLowerCase() === 'true';
  const surveyId = params.get('surveyId') || params.get('survedyId');

  useEffect(() => {
    // Temporary Fix For Exco TT

    const code = params.get('j');

    const storedEmail = localStorage.getItem('p_j');

    if (!params.get('j')) {
      setIsURLValid(false);
    } else {
      setJoinCode(params.get('j'));
      setIsURLValid(true);

      const paramsToExclude = ['j', 'm'];
      const queryParams = getQueryParameters(location.search, paramsToExclude);

      setUserMetadata({ ...userMetadata, ...queryParams });

      if (code === 'XOTUDQHU' || code === 'QN0K1DZU' || code === 'EF7A195R' || code === 'YGWHIJJ2')
        setCommId(storedEmail);

      axios
        .get(`${API_URL}/accounts/no-auth/web-form/${params.get('j')}`)
        .then((data) => {
          setAccountLogo(data.data.Data.logo);
          setAccountId(data.data.Data.accountId);
          const surveyMetadata = data?.data?.Data?.surveyMetadata;

          try {
            if (surveyMetadata) {
              if (
                surveyMetadata?.find((metadata) => metadata?.name === 'webSurveyInputType')
                  ?.value === 'PHONE'
              )
                setHasEmail(false);
              if (
                surveyMetadata?.find((metadata) => metadata?.name === 'webSurveyInputType')
                  ?.value === 'PHONE_AND_EMAIL'
              )
                setEmailOrPhone(true);
              if (
                surveyMetadata?.find((metadata) => metadata?.name === 'webSurveyPlatform')
                  ?.value === 'TWITTER'
              )
                setHasTwitter(true);
              if (
                surveyMetadata?.find((metadata) => metadata?.name === 'webSurveyPlatform')
                  ?.value === 'INSTAGRAM'
              )
                setHasInstagram(true);
              if (
                surveyMetadata?.find((metadata) => metadata?.name === 'webSurveyPlatform')
                  ?.value === 'FACEBOOK'
              )
                setHasFacebook(true);
            }
            setLoading(false);
          } catch (e) {
            console.log(e);
          }
        })
        .catch((error) => console.error("Couldn't get account data : ", error));
    }
  }, []);
  useEffect(() => {
    if (accountId === '73450') {
      document.body.classList.add('tappi-custom');
    } else if (accountId === '132990') {
      document.body.classList.add('nutrigo-custom');
    } else {
      document.body.classList.remove('tappi-custom');
      document.body.classList.remove('nutrigo-custom');
    }
  }, [accountId]);

  const isTappi = accountId === '73450';
  const isNutriGo = accountId === '132990';

  const handlePhoneChange = (value) => {
    setPhoneValue(value);
    if (!value) {
      setPhoneError('');
    } else if (!isValidPhoneNumber(value)) {
      setPhoneError('Please enter a valid phone number');
    } else {
      setPhoneError('');
    }
  };

  const onSubmit = (event) => {
    event.preventDefault();

    const formData = new FormData(event.target);
    if (hasEmail) {
      setCommId(formData.get('email'));
    } else {
      if (!phoneValue || !isValidPhoneNumber(phoneValue)) {
        setPhoneError('Please enter a valid phone number');
        return;
      }

      const phone = phoneValue.replace(/\+/g, '').replace(/\s/g, '');

      setCommId(phone);
    }
    // Temporary Fix For Exco TT
    if (joinCode === 'VYYFUE8X') {
      localStorage.setItem('p_j', formData.get('email'));
    }

    if (hasFacebook)
      setUserMetadata({ ...userMetadata, facebookUsername: formData.get('facebook') });
    if (hasTwitter) setUserMetadata({ ...userMetadata, twitterUsername: formData.get('twitter') });
    if (hasInstagram)
      setUserMetadata({ ...userMetadata, instagramUsername: formData.get('instagram') });
  };

  const handleOptionChange = (e) => {
    setSelectedContactMethod(e.target.value);
    if (e.target.value === 'email') {
      setHasEmail(true);
      setPhoneError('');
    } else {
      setHasEmail(false);
    }
  };

  return (
    <>
      <Helmet>
        <title>Ajua Webforms | Home</title>
      </Helmet>
      {loading && (
        <div
          style={{
            zIndex: '999999',
            background: 'white',
          }}
        >
          <div className="loader-container">
            <Loader
              // css={override}
              size={50}
              color="#2196f3"
              loading={loading}
            />
          </div>
        </div>
      )}
      {isUrlValid && !loading && (
        <>
          {isPreview ? (
            <WebformPreview joinCode={joinCode} surveyId={surveyId} />
          ) : commId ? (
            <WebForm joinCode={joinCode} commId={commId} userMetadata={userMetadata} />
          ) : (
            <div className="container landing-page-wrapper">
              <div className="customer-logo">
                <img src={accountLogo} className="customer-account-avatar" alt="account logo"></img>
              </div>
              <form onSubmit={onSubmit} style={{ maxWidth: '800px', margin: '0 auto' }}>
                <p className="fw-300">
                  {joinCode === 'CSWXUK28' ? ( // KCB
                    <div>
                      <h4 className="text-center">CUSTOMER FEEDBACK / MREJESHO WA HUDUMA</h4>
                      <div>
                        Dear Customer, thank you for choosing KCB. As part of enhancing our
                        services, kindly participate in rating your experience with KCB. Your
                        feedback is valuable to us.
                      </div>
                      <div className="mt-1">
                        Mpendwa Mteja, asante kwa kuchagua KCB. Ili kuboresha huduma zetu tunakuomba
                        ushiriki katika kutupatia maoni.
                      </div>
                      <div>Please share contact information:</div>
                    </div>
                  ) : joinCode === 'JCLWQ0' ? ( // NutriGo
                    <div>
                      <div>
                        This survey is being conducted by beverage manufacturer,{' '}
                        <b>BiaGo Limited</b>. It is aimed at helping us understand your beverage
                        consumption patterns before introducing a new product to the Kenyan Market.
                      </div>
                      <div className="mt-1">
                        When you submit this form, it will not automatically collect your details
                        like name and email address unless you provide it yourself.
                      </div>
                    </div>
                  ) : (
                    <>
                      {accountId == 132862 ? ( // ICEA LION
                        <div>
                          <div>Dear Customer, thank you for choosing ICEA LION.</div>
                          <div className="mt-1">
                            Based on your current interaction we invite you to participate in a
                            short survey to help us improve customer experience. Confirm your email
                            address and click Proceed to continue.
                          </div>
                        </div>
                      ) : (
                        'To proceed with this survey, please provide us with your contact information.'
                      )}
                    </>
                  )}
                </p>

                {isEmailOrPhone && (
                  <div style={{ display: 'flex', gap: 20 }}>
                    <label style={{ fontWeight: 300 }}>
                      Email
                      <input
                        type="radio"
                        value="email"
                        checked={selectedContactMethod === 'email'}
                        onChange={handleOptionChange}
                      />
                    </label>

                    <label style={{ fontWeight: 300 }}>
                      Phone
                      <input
                        type="radio"
                        value="phone"
                        checked={selectedContactMethod === 'phone'}
                        onChange={handleOptionChange}
                      />
                    </label>
                  </div>
                )}
                <div className="row g-3">
                  {hasEmail ? (
                    <div className="col">
                      <label htmlFor="ajWebformEmailInput" className="form-label mb-2 fw-300">
                        Email
                      </label>
                      <input
                        type="email"
                        className="form-control"
                        id="ajWebformEmailInput"
                        name="email"
                        required
                        placeholder="juma@mail.com"
                      />
                    </div>
                  ) : (
                    <div className="col">
                      <label htmlFor="webFormPhoneInput" className="form-label mb-2 fw-300">
                        {joinCode === 'CSWXUK28' ? <>Phone No. / Namba ya Simu</> : <>Phone No.</>}
                      </label>
                      {joinCode === 'T8OJFYY6' ? (
                        <input
                          type="tel"
                          className="form-control"
                          id="webFormPhoneInput"
                          name="phone"
                          required
                          placeholder="+234712345678"
                          //pattern="\+234[7-9][0-1][0-9]{8}"
                          //maxLength="14"
                        />
                      ) : (
                        <>
                          <PhoneInput
                            international
                            defaultCountry="KE"
                            name="phone"
                            value={phoneValue}
                            onChange={handlePhoneChange}
                            className={`form-control ajua-phone-input${
                              phoneError ? ' is-invalid' : ''
                            }`}
                          />
                          {phoneError && (
                            <div
                              className="invalid-feedback d-block"
                              style={{ color: '#dc3545', fontSize: 12, marginTop: 4 }}
                            >
                              {phoneError}
                            </div>
                          )}
                        </>
                      )}
                    </div>
                  )}
                </div>
                <div className="row g-3 mt-3">
                  {hasFacebook && (
                    <div className="col">
                      <label htmlFor="webFormFacebook" className="form-label mb-2 fw-300">
                        Facebook username
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="webFormFacebook"
                        name="facebook"
                        required
                        placeholder="jumaHassan"
                      />
                    </div>
                  )}
                  {hasTwitter && (
                    <div className="col">
                      <label htmlFor="webFormTwitter" className="form-label mb-2 fw-300">
                        Twitter Username
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="webFormTwitter"
                        name="twitter"
                        required
                        placeholder="jumaHassan"
                      />
                    </div>
                  )}
                  {hasInstagram && (
                    <div className="col">
                      <label htmlFor="webFormInstagram" className="form-label mb-2 fw-300">
                        Instagram username
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="webFormInstagram"
                        name="instagram"
                        required
                        placeholder="jumaHassan"
                      />
                    </div>
                  )}
                </div>
                <div className="mt-1 mb-3">
                  <small className="small my-1" style={{ fontSize: 10 }}>
                    By providing your information, you agree to sharing your feedback guided by our{' '}
                    <a
                      href="https://ajua.com/privacy-policy"
                      target="_blank"
                      rel="noopener noreferrer"
                      className={isNutriGo || isTappi ? 'powered-by-ajua-custom' : ''}
                    >
                      Privacy Policy
                    </a>
                  </small>
                </div>
                <button
                  className={
                    isNutriGo || isTappi
                      ? 'btn btn-primary tappi-btn mt-3'
                      : 'btn btn-primary kq-red mt-3'
                  }
                  type="submit"
                >
                  Proceed
                </button>
                <section className="powered-by-ajua">
                  <p className="small" style={{ display: 'flex', alignItems: 'center' }}>
                    <span className={isTappi ? 'powered-by-ajua-custom' : ''}>Powered by </span>
                    <a href="https://ajua.com" target={'_blank'} rel="noopener noreferrer">
                      <img
                        src="/icons/icon-512x512.png"
                        className="ajua-logo-image"
                        alt="ajua logo"
                        style={{ height: '2rem' }}
                      />
                    </a>
                  </p>
                </section>
              </form>
            </div>
          )}
        </>
      )}
      {!isUrlValid && <Navigate to="/404" />}
    </>
  );
}
